<template>
  <el-main class="el-mainContent">
    <p class="el-divider-header smallHeader">{{$t('policy')}}</p>
    <el-form label-position="top"  size="small" class="demo-form-inline">
      <el-row>
        <el-col :span="6">
          <el-form-item :label="$t('min_length')"  class="padding0Label">
            <el-input class="input-width" v-model="detail.length"></el-input>
            <div class="tip-text">{{$t('max_length_tip')}}</div>
          </el-form-item>
        </el-col>
        <!-- offset="3" -->
        <el-col :span="6" :offset="6">
          <el-form-item :label="$t('failLoginTimes')"  class="padding0Label">
            <el-input class="input-width" v-model="detail.failLoginTimes"></el-input>
            <div class="tip-text">{{$t('nocheck')}}</div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <el-form-item :label="$t('legal')"  class="padding0Label">
            <el-switch v-model="detail.legal"  active-value="1" inactive-value="0"></el-switch>
          </el-form-item>
        </el-col>
        <!-- offset="3" -->
        <!-- <el-col :span="6" :offset="6">
          <el-form-item label="修改密码时不可与前几次相同,规定次数为："  class="padding0Label">
            <el-input class="input-width" v-model="detail.maxUpdateTimes"></el-input>
          </el-form-item>
          <div class="tip-text">（不填则不做此项检查）</div>
        </el-col> -->
      </el-row>
    </el-form>

    <p class="el-divider-header smallHeader">{{$t('pwd_change')}}</p>
    <!-- <el-divider content-position="left" class="el-divider-header">密码修改通知策略</el-divider> -->
    <el-form :inline="true" class="demo-form-inline"  size="small">
      <el-form-item :label="$t('noticeAuthor')"  class="padding0Label">
        <el-switch v-model="detail.noticeAuthor"  active-value="0" inactive-value="1"></el-switch>
      </el-form-item>
    </el-form>
    <el-form v-if="detail.noticeAuthor=='1'" label-position="top"  size="small">
      <el-row>
        <el-col :span="6">
          <el-form-item :label="$t('maxAge')"  class="padding0Label">
            <el-input class="input-width" v-model="detail.maxAge"></el-input>
          </el-form-item>
        </el-col>
        <!-- offset="3" -->
        <el-col :span="6" :offset="6">
          <el-form-item :label="$t('noticeTime')"  class="padding0Label">
            <el-input class="input-width" v-model="detail.noticeTime"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <el-form-item :label="$t('noticeMethodArr')"  class="padding0Label">
            <el-checkbox-group v-model="noticeMethodArr">
              <el-checkbox label="1">{{$t('sms')}}</el-checkbox>
              <el-checkbox label="2">{{$t('msg_center')}}</el-checkbox>
              <el-checkbox label="3">{{$t('email')}}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-col>
      
        <el-col :span="6" :offset="6">
          <el-form-item :label="$t('noticeContent')"  class="padding0Label">
            <el-input class="input-width" v-model="detail.noticeContent" name="textarea"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </el-main>
</template>

<script>


export default {
  data(){
    return {
      noticeMethod:[]
    }
  },
  props:["detail"],
  watch:{
    detail(newVal){
      this.detail=newVal;
      this.noticeMethod = this.detail.noticeMethod ? this.detail.noticeMethod.split(",") : [];
    }
  },
  computed:{
    noticeMethodArr:{
      set(val){
        this.noticeMethod=val;
        this.detail.noticeMethod=this.noticeMethod.join(",")
        return this.noticeMethod
      },
      get(){
        return this.noticeMethod

      },
    }
  },
  created() {
    
  },
  methods: {
    
  },
};
</script>
<style lang="scss" scoped>

</style>